import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Box, getSemanticValue, Logo } from '@freenow/wave';

import { ROUTES } from '../../routing/constants/routes';
import { SignUpFooter } from './SignUpFooter';
import { LocaleContext } from '../../common/context/LocaleContext';

const Background = styled(Box)`
    background-color: ${getSemanticValue('background-page-elevation-0')};
    min-height: 100vh;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const SignUpWrapper = ({ children }: { children: React.ReactNode }) => {
    const { locale } = useContext(LocaleContext);
    const monochromeLogo = locale === 'fr';

    return (
        <Background px={2}>
            <Box my={5} mx="auto">
                <Link to={ROUTES.LOGIN}>
                    <Logo variant="business" monochrome={monochromeLogo} width="180px" height="auto" />
                </Link>
            </Box>
            <Box flexGrow={1} mb={5}>
                {children}
            </Box>
            <SignUpFooter />
        </Background>
    );
};
